var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "saas-page linear-admin-workflow" }, [
    _c("div", { staticClass: "saas-hero card-saas linear-page-hero" }, [
      _c("div", { staticClass: "saas-hero__main" }, [
        _c(
          "p",
          { staticClass: "saas-hero__crumb" },
          [
            _c("router-link", { attrs: { to: "/home" } }, [
              _vm._v(_vm._s(_vm.trans("general.home"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("router-link", { attrs: { to: "/todo" } }, [
              _vm._v(_vm._s(_vm.trans("todo.todo"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.trans("todo.edit_todo")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("h1", { staticClass: "saas-hero__title" }, [
          _vm._v(_vm._s(_vm.trans("todo.edit_todo"))),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "linear-page-copy" }, [
          _vm._v(_vm._s(_vm.trans("todo.todo"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row linear-admin-workflow__grid" }, [
      _c("div", { staticClass: "col-12 col-lg-7" }, [
        _c(
          "div",
          { staticClass: "card-saas linear-admin-panel" },
          [_c("todo-form", { attrs: { id: _vm.id } })],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }